import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { getImageUrl } from "../../redux/types";

const useStyles = makeStyles((theme) => ({
  container: {
    cursor: "pointer",
  },
  cover: {
    paddingTop: theme.spacing(2),
    height: "20vh",
    width: "20vh",
    objectFit: "contain",
    "&:hover": {
      borderRadius: 20,
      backgroundColor: "white",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(0),

      height: "10vh",
      width: "10vh",
    },
  },
  card: {
    width: "25vh",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.5s ease",
    boxShadow: "none",
    "&:hover": {
      borderRadius: 20,
      backgroundColor: "white",
      boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      borderRadius: 20,
      height: "22vh",
      backgroundColor: "white",
      "&:hover": {
        borderRadius: 20,
        backgroundColor: "white",
      },
    },
  },
  title: {
    fontSize: "1.2rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      //   fontWeight: "500",
    },
  },
  CardContent: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),

      //   fontWeight: "500",
    },
  },
}));

const IconItem = ({ data }) => {
  const history = useHistory();
  const classes = useStyles();
  const handleNavigate = (data) => {
    const { link, extenral } = data;

    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(`${link}`);
  };
  return (
    <Grid
      item
      lg={3}
      md={3}
      sm={4}
      xs={4}
      container
      className={classes.container}
      alignItems="center"
      justify="center"
      onClick={() => handleNavigate(data)}
    >
      <div className={classes.card}>
        <img src={getImageUrl(data.image)} className={classes.cover} />
        <div className={classes.CardContent}>
          <Typography className={classes.title}>{data.title}</Typography>
        </div>
      </div>
    </Grid>
  );
};
export default IconItem;
